export const FEATURES = {
	DASHBOARD: { key: "dashboard" },
	BOOKINGS: { key: "bookings" },
	VEHICLES: { key: "vehicles" },
	DRIVERS: { key: "drivers" },
	CARDS: { key: "cards" },
	CHARGING_SESSIONS: { key: "charging-sessions" },
	CHARGING_STATIONS: {
		key: "charging-stations",
		environments: ["development", "staging"],
	},
	// MONITORING: { key: "monitoring" },
	TRIPS: { key: "trips" },
	BILLING: { key: "billing" },
	TASKS: { key: "tasks" },
	SYSTEM_STATUS: { key: "system-status" },
	VEHICLE_BASE_LOCATIONS: { key: "vehicle-base-locations" },
	VEHICLE_GROUPS: { key: "vehicle-groups" },
	RATE_CARDS: {
		key: "rate-cards",
		environments: ["development", "local-backend", "staging", "production"],
	},
	CLIENTS: { key: "clients" },
	USERS: { key: "users" },
} as const;
